import React, {useState, useRef, useEffect} from 'react';
import {injectIntl} from 'react-intl';
import axios from 'axios';
import getFormConfig from 'getFormConfig';
import FormField from '@FormComponents/FormField';
import Button from '@FormComponents/Button';
import Icon from '@Components/Icon';
import Toast from '@Components/Toast';
import dispatchRerender from 'dispatchRerender';
import {useHistory, useRouteMatch, useLocation} from 'react-router-dom';

const SubscribeFormModal = ({intl, staticContext, keyword, location}) => {
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const modal = useRef();
  const history = useHistory();
  const route = useRouteMatch();
  const search = useLocation().search;

  useEffect(() => {
    setState((prev) => {
      return {
        ...prev,
        job_title: keyword ?? prev.job_title,
        location: location ?? prev.location,
      };
    });
  }, []);

  useEffect(() => {
    // Re-attach orbit events.
    dispatchRerender();
  }, []);

  const onChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const renderForm = () => {
    const formConfig = getFormConfig()['subscribe_modal'];
    const fieldsForm = formConfig.map((field, i) => {
      const {name} = field;
      return (
        <FormField
          state={state}
          setState={setState}
          field={field}
          errors={errors}
          setErrors={setErrors}
          onChange={onChange}
          key={`component-${name}-${i}`} />
      );
    });

    const submitSubscribe = (event) => {
      setLoading(true);
      axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
        callback: '@Callbacks/employeeAlertsSubscribe',
        currentRoute: route,
        data: state,
      }).then((response) => {
        setErrors({});
        setLoading(false);
        history.push(`${route.url}${search}&#toast=job-alerts`);

        // Hide job alert modal.
        modal.current.classList.remove('modal--active');
        const html = document.getElementsByTagName('html');
        html[0].classList.remove('modal-open');
        dispatchRerender();
      }).catch((err) => {
        if (err.response?.data?.errors) {
          setErrors(err.response.data.errors);
        } else {
          setErrors({generalError: 'Subscribe.Form.GeneralError'});
        }
        setLoading(false);
      });
    };

    return (
      <>
        <div className="modal modal__job-alerts" data-rs-modal="get-job-alerts" ref={modal}>
          <div className="modal__dialog" role="dialog" aria-modal={true} aria-labelledby="#" data-rs-modal-dialog={true}>
            <div className="modal__header" data-rs-modal-header={true}>
              <div className="modal__title">
                { intl.formatMessage({id: 'SubscribeFormModal.Title'}) }
              </div>
              <button className="button--icon-only modal__close" data-rs-modal-close-trigger={true}>
                <span className="icon icon--inline hidden--from-l">
                  <Icon type="close"/>
                </span>
                <span className="icon icon--l icon--inline hidden--until-l">
                  <Icon type="close-30"/>
                </span>
              </button>
            </div>
            <div className="modal__main" data-rs-modal-main={true}>
              {fieldsForm}
            </div>
            <div className="modal__footer" data-rs-modal-footer={true}>
              <Button loading={loading} className="button button--full-width-to-icon button--filled button--m" onClick={submitSubscribe}>
                <span className="button__text">{ intl.formatMessage({id: 'SubscribeFormModal.ButtonText'}) }</span>
              </Button>
            </div>
          </div>
        </div>
        <Toast message={intl.formatMessage({id: 'SubscribeFormModal.Toast'})} anchor="job-alerts" />
      </>
    );
  };

  return (
    <div>{renderForm()}</div>
  );
};

export default injectIntl(SubscribeFormModal);
